/**
 * Association / ONG — the SYCEBNL vertical.
 *
 * Moved verbatim from the base profile registry; `accounting`, `funding` and
 * `reporting` are the only entries dropped, and only because `CORE_MODULES`
 * spread above them already grants all three.
 */
import { CORE_MODULES, CORE_ONBOARDING } from "../../sector/core-modules.js";
export const associationProfile = {
    code: "ASSOCIATION",
    label: "Association / ONG",
    description: "Entité à but non lucratif (régime SYCEBNL)",
    icon: "heart-handshake",
    modules: [
        ...CORE_MODULES,
        "accounting-dashboard", "accounting-entries",
        "accounting-etats-sycebnl", "accounting-donor-register", "accounting-funds",
        "budget", "projects",
    ],
    onboarding: [...CORE_ONBOARDING],
    terminology: {
        "nav.clients": "Bénéficiaires",
    },
    accountingSystem: "SYCEBNL",
    defaultPosMode: false,
    defaultPriceMode: "HT",
    psvbApplicable: false,
    categories: [],
    // No `audcifClass`: AUDCIF art. 13 classes commercial activities, and
    // SYCEBNL entities sit outside that perimeter
    // (docs/fiscal/2026-07-12-regimes-dsf.md:41).
    //
    // Group B is the standard rate, not a finding that a non-profit
    // invoices TVA — whether it invoices any is decided by its regime.
    defaultTaxGroup: "B",
};
//# sourceMappingURL=profile.js.map